import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class TableTypeResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.dataSources = [];
    }
    pk() {
        return this.displayName || "";
    }
}
TableTypeResource.urlRoot = apiResourceUrl("tableType");
export { TableTypeResource };
//# sourceMappingURL=TableTypeResource.js.map